import type { RiskLevel, WorkflowStep } from '@/types/dashboard'

export function riskClass(level: RiskLevel): 'g' | 'a' | 'r' {
  if (level === 'high') return 'r'
  if (level === 'medium') return 'a'
  return 'g'
}

export function meterClass(level: RiskLevel): '' | 'med' | 'hi' {
  if (level === 'high') return 'hi'
  if (level === 'medium') return 'med'
  return ''
}

export function riskWidth(level: RiskLevel): number {
  if (level === 'high') return 92
  if (level === 'medium') return 62
  return 28
}

export function confPct(confidence: number): number {
  return Math.max(4, Math.min(100, Math.round((confidence || 0) * 100)))
}

export function stepLabel(s: WorkflowStep | string | undefined): string {
  if (!s) return 'step'
  if (typeof s === 'string') return s
  return s.element?.text || s.description || s.type || 'step'
}

export function shortTime(ts: number): string {
  try {
    return new Date(ts).toLocaleString()
  } catch {
    return String(ts)
  }
}
